'use client';
import { useEffect } from 'react';

const LiveChat = ({ groupId }) => {
  useEffect(() => {
    if (typeof window !== 'undefined') {
      window.__lc = window.__lc || {};
      window.__lc.license = 10956587;
      window.__lc.integration_name = 'manual_channels';
      window.__lc.product_name = 'livechat';
      window.__lc.group = groupId;

      (function (n, t, ct) {
        function i(n) {
          return e._h ? e._h.apply(null, n) : e._q.push(n);
        }
        let e = {
          _q: [],
          _h: null,
          _v: '2.0',
          on: function () {
            i(['on', ct.call(arguments)]);
          },
          once: function () {
            i(['once', ct.call(arguments)]);
          },
          off: function () {
            i(['off', ct.call(arguments)]);
          },
          get: function () {
            if (!e._h) throw new Error("[LiveChatWidget] You can't use getters before load.");
            return i(['get', ct.call(arguments)]);
          },
          call: function () {
            i(['call', ct.call(arguments)]);
          },
          init: function () {
            let n = t.createElement('script');
            n.async = !0;
            n.type = 'text/javascript';
            n.src = 'https://cdn.livechatinc.com/tracking.js';
            t.head.appendChild(n);
          },
        };
        !n.__lc.asyncInit && e.init(), (n.LiveChatWidget = n.LiveChatWidget || e);
      })(window, document, [].slice);
    }
  }, []);

  return (
    <noscript>
      <a href="https://www.livechat.com/chat-with/10956587/" rel="nofollow">
        Chat with us
      </a>
      , powered by{' '}
      <a href="https://www.livechat.com/?welcome" rel="noopener nofollow" target="_blank">
        LiveChat
      </a>
    </noscript>
  );
};

export default LiveChat;
